import { Box, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolIcon, SwissIcon } from '@synergy/theme-next';
import { PoolTooltip } from '@synergy/components-next';
import { ReactElement } from 'react';

import { SupplierListItemBoxProps } from './supplier-list-item-box-props';

const IconContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    float: 'right',
}));

export const SupplierListBoxIcons = (props: SupplierListItemBoxProps): ReactElement => {
    const isSwiss = props.item.address?.countryName === 'Schweiz';
    const isChargingSupplier = props.item.isChargingSupplier;

    return (
        <IconContainer>
            <PoolTooltip
                mobileClickToOpen={true}
                preventPropagation={true}
                title={
                    <FormattedMessage
                        id={
                            isChargingSupplier
                                ? 'app.supplierDirectory.card.pool'
                                : 'app.supplierDirectory.card.pool.disabled'
                        }
                    />
                }
            >
                <PoolIcon sx={{ opacity: isChargingSupplier ? 1 : 0.2, fontSize: theme => theme.spacing(3.5) }} />
            </PoolTooltip>
            {isSwiss && (
                <PoolTooltip
                    mobileClickToOpen={true}
                    preventPropagation={true}
                    title={<FormattedMessage id="app.supplierDirectory.card.swiss" />}
                >
                    <SwissIcon sx={{ fontSize: theme => theme.spacing(3.5) }} />
                </PoolTooltip>
            )}
        </IconContainer>
    );
};
